import React from 'react'
import Footer from './Footer'
import Header from './Header'
import Create_order_nav from './Create_order_nav'
import Create_order_steps from './Create_order_steps'

import axios from 'axios'
import queryString from 'query-string';
import { useNavigate,useLocation } from 'react-router-dom';

import Swal from 'sweetalert2'

import config from "../../config"
import { useNetworkState } from 'react-use';
import Create_order_nav_b2b from './Create_order_nav_b2b'
import Create_order_steps_b2b from './Create_order_steps_b2b'

const Create_order_b2b_1 = () => {
  let navigate = useNavigate()
  const location = useLocation()
  const isOnline = useNetworkState();
  console.log("isONline  === " ,isOnline )
  // console.log("location==>122", location)
   let  parsed = queryString.parse(location.search);
   console.log("parsed",parsed);
  const [defaultCountry, setDefaultCountry] = React.useState({country_id:0})

  const [selectedOption, setSelectedOption] = React.useState(null);
 

  const [options, setOptions] = React.useState([]);
  const[addstate , addSetState] = React.useState({receiver_name:"",receiver_email:"",receiver_mobile:"",receiver_address:"",receiver_country: "", receiver_country_code: "", receiver_postal_code: "", receiver_city: "", receiver_state_name:"",receiver_city_id:"" , receiver_state_id:"", mode:"",error:{} });
  console.log("addstate==== " , addstate)
  const[domesticmode,setdomesticmodeState] = React.useState({domestic:false})
 
  const[internationalmode,setinternationalmodeState] = React.useState({international:false})
 
  const [errorState, setErrorState] = React.useState({receiver_mobile:"" , receiver_email:"" })
  const [countryList, setcountryList] = React.useState([]);
  const [stateList, setStateList] = React.useState([]);
  const [cityList, setCityList] = React.useState([]);
  const [pincodeList, setPincodeList] = React.useState([]);
  const[country,setCountry] = React.useState({country_id:""})

  const [pincode, setPincode] = React.useState('');
const [newstate, setnewState] = React.useState('');
const [newcity, setnewCity] = React.useState('');
const [newstateid, setnewStateid] = React.useState('');
const [newcityid, setnewCityid] = React.useState('');


const[carriertype,setcarriertype]= React.useState({type:2})
const[ordertype,setordertype]= React.useState({type:1})



   
  let userDetail = localStorage.getItem('ship_rocket_user');
  
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail)
  }

  React.useEffect(()=>{
     
      getCountryList()
      list()
  },[])

  React.useEffect(()=>{
     
   
   list()
},[parsed.value])
   

    React.useEffect(() => {
      if (parsed.receiver_postal_code && parsed.receiver_postal_code.length >= 3) {
        // Fetch details based on the pincode from the URL
        handlePincodeChange({ target: { value: parsed.receiver_postal_code } });
      }
    }, [parsed.receiver_postal_code , country.country_id]);

  const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000
    })
 
    React.useEffect(()=>{
      if(parsed.carrier_type){
       setcarriertype({type:parsed.carrier_type})
      }
    },[parsed.carrier_type])

    React.useEffect(()=>{
     if(parsed.order_type){
      setordertype({type:parsed.order_type})
     }
   },[parsed.order_type])
  
   

    const fetchDetailsFromPincode = async (enteredPincode) => {
      try {
        // Replace 'your-api-endpoint' with the actual endpoint of your backend
        const url = config.apiUrl + '/country/automate_pincode';
        
        // Assuming your API expects a POST request with the entered pincode
        const sendData = { enteredPincode , country_id: country.country_id};
        console.log("sendData == " , sendData)
    
        const response = await axios.post(url, sendData);
    
        // Assuming your API returns an object with state and city properties
        const { state, city , state_id , city_id } = response.data;
    
        return { state, city , state_id , city_id };
      } catch (error) {
        console.error('Error fetching details:', error);
        return {
          state: '',
          city: '',
          state_id:'',
          city_id:'',
        };
      }
    };
    const handlePincodeChange = async (e) => {
      const newPincode = e.target.value;
  
      // Update pincode state
      setPincode(newPincode);
  
      // Check if the length is at least three characters
      if (newPincode.length >= 3) {
        // Fetch details based on the pincode
        const { state: newState, city: newCity , state_id: newStateid , city_id:newCityid } = await fetchDetailsFromPincode(newPincode);
  
        // Update state and city inputs
        setnewState(newState);
        setnewCity(newCity);
        setnewStateid(newStateid);
        setnewCityid(newCityid);
      } else {
        // Reset state and city if the pincode is less than three characters
        setnewState('');
        setnewCity('');
      }
    };
    const getCountryList = () => {


      let url = config.apiUrl + '/country/country_list_international';
      let sendData = {limit:300 , status:1};
      // console.log("bb", sendData);
      axios.post(url, sendData, { headers: config.headers }).then((res) => {
          // console.log("res ", res);           
          setcountryList(res.data.output)
  
  
      }).catch((e) => {
  
  
      });
  }
  const getStateList = (country_id) => {


      let url = config.apiUrl + '/country/state_list';
      let sendData = { t_country_id: country_id, limit: 1000 };
      //  console.log("bb", sendData);
      axios.post(url, sendData, { headers: config.headers }).then((res) => {
          //  console.log("state ", res);           
          setStateList(res.data.output)
  
  
      }).catch((e) => {
  
  
      });
  }
 
     const getPincodeList = async (value) => {
      try {
        // console.log("value", value);
        let url = config.apiUrl + '/country/pincode_list';
        let sendData = { city_id: value };
        // console.log("bb", sendData);
        
        const response = await axios.post(url, sendData, { headers: config.headers });
        
        setPincodeList(response.data.output);
        let data = response.data.output;
        const transformedOptions = data.map(item => ({
          value: item.postal_code,
          label: item.postal_code
        }));
        // console.log("transformedOptions == ", transformedOptions);
        setOptions(transformedOptions);
        const matchedOption = transformedOptions.find(option => option.value === parsed.receiver_postal_code);
        // console.log("matchedOption",matchedOption)
        if (matchedOption) {
          setSelectedOption(matchedOption);
        }
        
     
      } catch (error) {
        // console.error(error);
        throw error; 
      }
    };
    
    
    
    const getCityList = (value) => {
    
    //  console.log("value",value)
     let url = config.apiUrl + '/country/city_list';
        let sendData = { state_id: value.state_id,country_id:value.country_id, limit: 1000 };
        // console.log("bb", sendData);
        axios.post(url, sendData, { headers: config.headers }).then((res) => {
            // console.log("city  ", res);           
            setCityList(res.data.output)
    
    
        }).catch((e) => {
    
    
        });
    }

    const list = async()=>{
      if(parsed.value==0){
      let url = config.apiUrl + '/country/country_list';
      let senddata = {}
      const responseJson = await axios.post(url, senddata, { headers: config.headers });
          //  console.log("responseJson => ", responseJson.data.defaultCountry);
     
          setDefaultCountry(responseJson.data.defaultCountry)
          addSetState({...addstate, receiver_country:responseJson.data.defaultCountryName , receiver_country_code:responseJson.data.defaultCountrycode ,  receiver_name:parsed.receiver_name?parsed.receiver_name:"" , receiver_mobile:parsed.receiver_mobile?parsed.receiver_mobile:"" , receiver_email:parsed.receiver_email?parsed.receiver_email:"" , receiver_address:parsed.receiver_address?parsed.receiver_address:"" , receiver_state_name:parsed.receiver_state_name?parsed.receiver_state_name:"" , receiver_city:parsed.receiver_city?parsed.receiver_city:"" , receiver_postal_code: parsed.receiver_postal_code?parsed.receiver_postal_code:"" ,receiver_city_id:parsed.receiver_city_id?parsed.receiver_city_id:"" , receiver_state_id:parsed.receiver_state_id?parsed.receiver_state_id:"" ,  mode:parsed.mode?parsed.mode:"Domestic" })
          // setSelectedOption(parsed.receiver_postal_code?parsed.receiver_postal_code:null)
        
          setStateList([])
          setCityList([])
  
          // setOptions([])
           setCountry({country_id:responseJson.data.defaultCountry})
         //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
             getStateList(responseJson.data.defaultCountry)

             if(parsed.receiver_state_id!=undefined && parsed.receiver_state_id!=""){
              getCityList({state_id:parsed.receiver_state_id, country_id:responseJson.data.defaultCountry})
              if(parsed.receiver_city_id!=undefined && parsed.receiver_city_id!=""){
               let pincode = await getPincodeList(parsed.receiver_city_id) 
  }
            }
        }
      else{
          setdomesticmodeState({...domesticmode,domestic:false})
          setinternationalmodeState({...internationalmode,international:true})
           addSetState({...addstate,mode:"International" , receiver_country:"" , receiver_country_code:"" , receiver_city:"" , receiver_postal_code:"" , receiver_state_name:""})
           setSelectedOption(null)
           setOptions([])
         
           setCountry({country_id:""})
           setCityList([])
           setStateList([])
      }
    }
    
    const handleChange=(e)=>{
     
      let names = e.target.name
      let value= e.target.value

     
     
      if(e.target.type=="text"){
          addSetState({...addstate,[e.target.name]:value})
      }
      else if(e.target.type=="radio"){
          if(e.target.checked==true){
              if(e.target.name=="mode_domestic"){
                  setdomesticmodeState({...domesticmode,domestic:true})
                  setinternationalmodeState({...internationalmode,international:false})
                  //  addSetState({...addstate,mode:"Domestic"})
                       let url = config.apiUrl + '/country/country_list';
                       let senddata = {}
                       axios.post(url, senddata, { headers: config.headers })
                         .then((responseJson) => {
                            // console.log("responseJson => ", responseJson.data.defaultCountry);
                      
                           setDefaultCountry(responseJson.data.defaultCountry)
                           addSetState({...addstate ,mode:"Domestic", receiver_country:responseJson.data.defaultCountryName , receiver_country_code:responseJson.data.defaultCountrycode , receiver_city:"" , receiver_state_name:"" , receiver_postal_code:""})
                           setStateList([])
                           setCityList([])
                           setSelectedOption(null)
                           setOptions([])
                            setCountry({country_id:responseJson.data.defaultCountry})
                          //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
                              getStateList(responseJson.data.defaultCountry)
                      
                         })
                         .catch((error) => {
                           
                          //  console.error(error);
                         });
                     

              }
              else if(e.target.name=="mode_international"){
                  setdomesticmodeState({...domesticmode,domestic:false})
                  setinternationalmodeState({...internationalmode,international:true})
                   addSetState({...addstate,mode:"International" , receiver_country:"" , receiver_country_code:"" , receiver_city:"" , receiver_postal_code:"" , receiver_state_name:""})
                   setSelectedOption(null)
                   setOptions([])
                 
                   setCountry({country_id:""})
                   setCityList([])
                 //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
                setStateList([])
              }
            
          }
      }
      else if(e.target.type=="number"){
          var re = new RegExp("^.{10}$");
          // console.log(value,"   regex number check =   ",re.test(value))
          setErrorState({ ...errorState, receiver_mobile: "" })
          if (re.test(value)) {
            re = new RegExp("^[0-9]+$");
            if (!re.test(value)) {
              setErrorState({ ...errorState, receiver_mobile: "Please enter valid number" })
              //console.log("please enter valid number")
            }
          } else {
            setErrorState({ ...errorState, receiver_mobile: "Please enter 10 digit number " })
           // return(null)
            //console.log("please check length")
          }
          addSetState({...addstate,[e.target.name]:value})
      }
      else if(e.target.type=="email"){
          setErrorState({ ...errorState, receiver_email: "" })
          addSetState({...addstate , receiver_email:e.target.value})
      }
     
     
     
  }
 
 const next_step = () => {
   let cleanedReceiverAddress = addstate.receiver_address;
 
   // Check if '#' exists in receiver_address, then remove it
   if (cleanedReceiverAddress.includes('#')) {
     cleanedReceiverAddress = cleanedReceiverAddress.replace(/#/g, '');
   }
 
   let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 
   if (addstate.receiver_name != "") {
     if (re.test(addstate.receiver_email!=""?addstate.receiver_email:"abc@gmail.com") ) {
       if (addstate.receiver_mobile != "") {
         if (addstate.receiver_mobile.length == 10) {
           if (addstate.receiver_address != "") {
             if (addstate.receiver_country != "") {
               
               // For Domestic mode, state, city, and postal code are required
               if (addstate.mode == "Domestic") {
                 if (pincode != "") {
                   if (newcity != "") {
                     if (newstate != "") {
                       navigateToNext(cleanedReceiverAddress);
                     } else {
                       showError("Please Select Receiver State");
                     }
                   } else {
                     showError("Please Select Receiver City");
                   }
                 } else {
                   showError("Please Select Receiver Postal Code");
                 }
               } 
               
               // For International mode, state, city, and postal code are not required
               else if (addstate.mode == "International") {
                 navigateToNext(cleanedReceiverAddress);
               }
 
             } else {
               showError("Please Select Receiver Country");
             }
           } else {
             showError("Please Fill Receiver Address");
           }
         } else {
           showError("Receiver Mobile must be 10 digit Number");
         }
       } else {
         showError("Please Fill Receiver Mobile");
       }
     } else {
       setErrorState({ ...errorState, receiver_email: "Please Enter Valid Email" });
       showError("Please Enter Valid Receiver Email");
     }
   } else {
     showError("Please Fill Receiver Name");
   }
 };
 
 // Function to handle navigation
 const navigateToNext = (cleanedReceiverAddress) => {
  //  navigate({
  //    pathname: '/create_order_2',
  //    search: `receiver_name=${addstate.receiver_name}&receiver_email=${addstate.receiver_email != "" ? addstate.receiver_email : ""}&receiver_mobile=${addstate.receiver_mobile}&receiver_address=${cleanedReceiverAddress}&receiver_country=${addstate.receiver_country}&receiver_country_code=${addstate.receiver_country_code}&receiver_postal_code=${pincode}&receiver_city=${newcity}&receiver_state_name=${newstate}&mode=${addstate.mode}&sender_name=${parsed.sender_name ? parsed.sender_name : ""}&sender_address=${parsed.sender_address ? parsed.sender_address : ""}&sender_country=${parsed.sender_country ? parsed.sender_country : ""}&sender_country_code=${parsed.sender_country_code ? parsed.sender_country_code : ""}&sender_postal_code=${parsed.sender_postal_code ? parsed.sender_postal_code : ""}&sender_state_name=${parsed.sender_state_name ? parsed.sender_state_name : ""}&sender_city=${parsed.sender_city ? parsed.sender_city : ""}&sender_address_id=${parsed.sender_address_id ? parsed.sender_address_id : ""}&sender_city_id=${parsed.sender_city_id ? parsed.sender_city_id : ""}&sender_mobile=${parsed.sender_mobile ? parsed.sender_mobile : ""}&sender_email=${parsed.sender_email ? parsed.sender_email : ""}&return_name=${parsed.return_name ? parsed.return_name : ""}&return_email=${parsed.return_email ? parsed.return_email : ""}&return_mobile=${parsed.return_mobile ? parsed.return_mobile : ""}&return_address=${parsed.return_address ? parsed.return_address : ""}&return_country=${parsed.return_country ? parsed.return_country : ""}&return_country_code=${parsed.return_country_code ? parsed.return_country_code : ""}&return_postal_code=${parsed.return_postal_code ? parsed.return_postal_code : ""}&return_city=${parsed.return_city ? parsed.return_city : ""}&return_state_name=${parsed.return_state_name ? parsed.return_state_name : ""}&items=${parsed.items ? parsed.items : ""}&shipment_type=${parsed.shipment_type ? parsed.shipment_type : ""}&insurance=${parsed.insurance ? parsed.insurance : ""}&order_id=${parsed.order_id ? parsed.order_id : ""}&order_date=${parsed.order_date ? parsed.order_date : ""}&weight=${parsed.weight ? parsed.weight : ""}&height=${parsed.height ? parsed.height : ""}&width=${parsed.width ? parsed.width : ""}&length=${parsed.length ? parsed.length : ""}&cod_amount=${parsed.cod_amount ? parsed.cod_amount : ""}&payment_mode=${parsed.payment_mode ? parsed.payment_mode : ""}&store_id=${parsed.store_id ? parsed.store_id : ""}&channel_name=${parsed.channel_name ? parsed.channel_name : ""}&volumetric_weight=${parsed.volumetric_weight ? parsed.volumetric_weight : ""}&dead_weight=${parsed.dead_weight ? parsed.dead_weight : ""}&receiver_state_id=${newstateid}&receiver_city_id=${newcityid}&carrier_type=${carriertype.type}&order_type=${ordertype.type}`
  //  });
  window.location.replace(`/create_order_b2b_2?receiver_name=${addstate.receiver_name}&receiver_email=${addstate.receiver_email != "" ? addstate.receiver_email : ""}&receiver_mobile=${addstate.receiver_mobile}&receiver_address=${cleanedReceiverAddress}&receiver_country=${addstate.receiver_country}&receiver_country_code=${addstate.receiver_country_code}&receiver_postal_code=${pincode}&receiver_city=${newcity}&receiver_state_name=${newstate}&mode=${addstate.mode}&sender_name=${parsed.sender_name ? parsed.sender_name : ""}&sender_address=${parsed.sender_address ? parsed.sender_address : ""}&sender_country=${parsed.sender_country ? parsed.sender_country : ""}&sender_country_code=${parsed.sender_country_code ? parsed.sender_country_code : ""}&sender_postal_code=${parsed.sender_postal_code ? parsed.sender_postal_code : ""}&sender_state_name=${parsed.sender_state_name ? parsed.sender_state_name : ""}&sender_city=${parsed.sender_city ? parsed.sender_city : ""}&sender_address_id=${parsed.sender_address_id ? parsed.sender_address_id : ""}&sender_city_id=${parsed.sender_city_id ? parsed.sender_city_id : ""}&sender_mobile=${parsed.sender_mobile ? parsed.sender_mobile : ""}&sender_email=${parsed.sender_email ? parsed.sender_email : ""}&return_name=${parsed.return_name ? parsed.return_name : ""}&return_email=${parsed.return_email ? parsed.return_email : ""}&return_mobile=${parsed.return_mobile ? parsed.return_mobile : ""}&return_address=${parsed.return_address ? parsed.return_address : ""}&return_country=${parsed.return_country ? parsed.return_country : ""}&return_country_code=${parsed.return_country_code ? parsed.return_country_code : ""}&return_postal_code=${parsed.return_postal_code ? parsed.return_postal_code : ""}&return_city=${parsed.return_city ? parsed.return_city : ""}&return_state_name=${parsed.return_state_name ? parsed.return_state_name : ""}&items=${parsed.items ? parsed.items : ""}&shipment_type=${parsed.shipment_type ? parsed.shipment_type : ""}&insurance=${parsed.insurance ? parsed.insurance : ""}&order_id=${parsed.order_id ? parsed.order_id : ""}&order_date=${parsed.order_date ? parsed.order_date : ""}&weight=${parsed.weight ? parsed.weight : ""}&height=${parsed.height ? parsed.height : ""}&width=${parsed.width ? parsed.width : ""}&length=${parsed.length ? parsed.length : ""}&cod_amount=${parsed.cod_amount ? parsed.cod_amount : ""}&payment_mode=${parsed.payment_mode ? parsed.payment_mode : ""}&store_id=${parsed.store_id ? parsed.store_id : ""}&channel_name=${parsed.channel_name ? parsed.channel_name : ""}&volumetric_weight=${parsed.volumetric_weight ? parsed.volumetric_weight : ""}&dead_weight=${parsed.dead_weight ? parsed.dead_weight : ""}&receiver_state_id=${newstateid}&receiver_city_id=${newcityid}&carrier_type=${carriertype.type}&order_type=${ordertype.type}`)
 };
 
 // Function to handle error notifications
 const showError = (message) => {
   Toast.fire({
     background: "#a61c09",
     type: 'unsuccess',
     title: message,
     color: "white"
   });
 };
 
    const onChangeLocationGeneral = (e) => {
     
       let values =   Object.assign({},e.target.value.split(',') )
      
       setCountry({country_id:values[0]})
       addSetState({...addstate , receiver_country:values[1] , receiver_country_code:values[2]  })
          getStateList(values[0])
     
    }
    const select_type =(e)=>{
     if(e.target.name=="b2c"){
       setcarriertype({type:1})
     }
     else{
       setcarriertype({type:2})
     }
   }
   const select_order_type =(e)=>{
     if(e.target.name=="normal"){
       setordertype({type:1})
     }
     else{
       setordertype({type:2})
     }
   }
  return (
    <div>
     
<Header/>
<div class="page-wrapper pinned">
 <div class="main-container">
  <div className='app-container'>
 <div class="app-body">
 <div class="container-fluid">

<div class="mob_nav">
  <div class=" d-flex justify-content-start ">
    <a href="javascript:window.history.back();" class=""><i class="bi bi-arrow-left"></i></a>
    <h2>Create Order</h2>
  </div>
</div>

<div class="row justify-content-between">
    <div class="col-12 col-md-4 desk_nav">
      <div class="d-flex">
        <a href="javascript:window.history.back();" class="back_btn"><i class="bi bi-arrow-90deg-left"></i></a>
        <h2>Create Order</h2>
      </div>
    </div>
    
</div>



<Create_order_nav_b2b/>
<hr/>
<div class="row">
    <div class="col-12 col-md-2">
   <Create_order_steps_b2b value={1}/>
    </div>
    <div class="col-12 col-md">
      <h4 class="pb-3">Add Buyer's Details</h4>
      <div class="card border-0 order_box">
        <div class="card-body">
          <section class="pb-5">
              <h6 class="mb-4">To whom is the order being delivered? <span class="text-muted">(Buyer's Info)</span></h6>
              <div class="row">
                  <div class="col-12 col-md-4 mb-3">
                      <label for="" class="form-label">Mobile Number:</label>
                      <div class="input-group">
                          <span class="input-group-text"><i class="bi bi-phone"></i></span>
                          <input type="text" class="form-control" placeholder="Enter Buyer's Mobile Number" name="receiver_mobile" onChange={(e)=>handleChange(e)} value={addstate.receiver_mobile}/>
                      </div>
                  </div>
                  <div class="col-12 col-md-4 mb-3">
                      <label for="" class="form-label">Full Name:</label>
                      <input type="text" class="form-control" id="" placeholder="Enter Full Name" name="receiver_name" onChange={(e)=>handleChange(e)} value={addstate.receiver_name}/>
                  </div>
                  <div class="col-12 col-md-4 mb-3">
                      <label for="" class="form-label">Email Id:</label>
                      <input type="text" class="form-control" id="" placeholder="Enter Email Id" name="receiver_email" onChange={(e)=>handleChange(e)} value={addstate.receiver_email}/>
                      {(errorState.receiver_email != "") ?
                                 <label><span className="text-danger">* {errorState.receiver_email}</span></label> : ""}
                  </div>
              </div>
          </section>

          <section>
              <h6 class="mb-4">Where is the order being delivered to? <span class="text-muted">(Buyer's Address)</span></h6>
              <div class="row">
                  <div class="col-12 col-md-12 mb-3">
                      <label for="" class="form-label">Complete Address:</label>
                      <input type="text" class="form-control" id="" placeholder="Enter Complete Address"  name="receiver_address" onChange={(e)=>handleChange(e)} value={addstate.receiver_address}/>
                  </div>
                  {parsed.value==1?
                           <div class="col-12 col-md-4 mb-3">
                               <label for="" class="form-label"  >Country:</label>
                               <select class="form-select form-select-sm" name="country_name" onChange={(e)=>onChangeLocationGeneral(e)}>
                               <option >Select</option>
                               {countryList.map((item)=>{
           return (
             <option value={[item.country_id , item.country_name , item.country_code]}>{item.country_name}</option>
         )
          
})}
                               </select>
                           </div>
                           :""}
                  <div class="col-12 col-md-4 mb-3">
                      <label for="" class="form-label">Pincode:</label>
                      <input type="text" class="form-control" id="" placeholder="Enter Pincode" value={pincode}
       onChange={handlePincodeChange}/>
                  </div>
                  <div class="col-6 col-md-4 mb-3">
                      <label for="" class="form-label">State:</label>
                      <input className='form-control' type='text' disabled='disabled' value={newstate}></input>
                  </div>
                  <div class="col-6 col-md-4 mb-3">
                      <label for="" class="form-label">City:</label>
                      <input className='form-control' type='text' disabled='disabled' value={newcity}></input>
                  </div>
              </div>
          </section>
          {/* <div class="py-3">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" checked=""/>
                <label class="form-check-label" for="inlineCheckbox1">Billing Address is same is Shipping Address</label>
              </div>
          </div> */}
        </div>
      </div>
      <div class="py-4 text-end">
          <a onClick={()=>next_step()} class="btn btn-primary">Start</a>
      </div>
    </div>
</div>




</div></div></div>
<Footer/></div></div>
    </div>
  )
}

export default Create_order_b2b_1
